// React
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { userSignUp } from "../Request/UserRequests";
import {
  saveAddress,
  saveUser,
  setCurrentLocation,
} from "../Redux/Actions/userActions";

import toast from "react-hot-toast";

import cookie from "react-cookies";

import { fetchLocation } from "../Request/LoginRequests";

import locationIcon from "../img/location-icon.png";
import locationIcon2 from "../img/location-icon2.png";

/**
 * User Via pin popup
 * @returns {JSX}
 */
function ViaPin() {
  const { t } = useTranslation();
  const [pin, setPin] = useState("");
  const [myareas, setMyareas] = useState([]);
  const [select, setSel] = useState(null);
  const [load, setLoad] = useState(false);
  const user = useSelector((s) => s.user.info);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [area, setArea] = useState("select");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [disable, setDisable] = useState(true);
  const [areaList, setList] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    handleClick();
  }, [pin]);

  function handleClick() {
    setLoad(true);
    fetchLocation("124507")
      .then((res) => {
        if (res.length) {
          setMyareas(res);
        }
      })
      .finally(() => setLoad(false));
  }

  function handleSignUp() {
    setSaving(true);
    userSignUp({
      name,
      phn: user?.phn,
      address: "",
      area: myareas[select].placeName,
      city: myareas[select].adminName3,
      state: myareas[select].adminName1,
      pin: myareas[select].postalCode,
    })
      .then((res) => {
        toast.success("Signed Up");
        cookie.save("uid", res.userHash, {
          path: "/",
          expires: new Date(new Date().setDate(new Date().getDate() + 360)),
        });
        dispatch(saveUser({ name, phn: user?.phn, userHash: res.userHash }));
        let cur = {
          name: "",
          address: "",
          area: myareas[select].placeName,
          city: myareas[select].adminName3,
          state: myareas[select].adminName1,
          pincode: myareas[select].postalCode,
          primary: "true",
          addressId: res.addressId,
          lat: myareas[select].Latitude,
          long: myareas[select].Longitude,
        };
        dispatch(saveAddress([{ ...cur }]));
        dispatch(setCurrentLocation(cur));
        setSaving(false);
        navigate("/home");
      })
      .catch((err) => {
        toast.error(err);
        setSaving(false);
      });
  }

  useEffect(() => {
    setSel(null);
  }, [pin]);

  return (
    <>
      {/* Span */}
      <span data-bs-target="#area" id="click"></span>
      <div
        className="round-top w-100 overflow-hidden animate-2 bg-white hide-2 pop-up d-none"
        style={{
          position: "absolute",
          bottom: "0",
          width: "100vw",
        }}
      ></div>

      {/* Select Area popup */}
      <div
        className="bg-white overflow-hidden animate d-none"
        style={{
          padding: "42px 16px 0",
          transition: "ease 0.5s",
          width: "100vw",
          height: "100vh",
          position: "relative",
          zIndex: "9999",
        }}
        tabIndex="-1"
        id="area"
      >
        {/* Header */}
        <div
          className="d-flex align-items-center justify-content-between"
          style={{ marginBottom: "4px" }}
        >
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "700",
              margin: "0",
              color: "#2B2B2B",
            }}
          >
            {t("Select Area")}
          </h2>
          <p
            className="d-flex align-items-center"
            style={{
              fontSize: "12px",
              fontWeight: "500",
              color: "#444",
              border: "1px solid #C8C8C8",
              borderRadius: "8px",
              padding: "3px",
              margin: "0",
            }}
          >
            <img
              src={locationIcon}
              alt=""
              width={16}
              className="d-block"
              style={{ marginRight: "4px" }}
            />
            {t("Bahadurgarh")} - 124507
          </p>
        </div>

        <div
          style={{
            marginBottom: "24px",
            color: "#444",
            fontSize: "14px",
            lineHeight: "130%",
            fontWeight: "500",
          }}
        >
          {t(
            "Right now, we deliver to these areas. Coming soon at other places!"
          )}
        </div>

        <div className="bg-white">
          {myareas.map((key, i) => (
            <div
              key={i}
              style={{ marginBottom: "12px" }}
              className={"selectArea" + (i === select ? " checked" : "")}
              onClick={() => setSel(i)}
              htmlFor={i}
            >
              123 {t(key.placeName + ", " + key.adminName3)}
            </div>
          ))}
        </div>
        <div className="d-flex" style={{ marginTop: "24px" }}>
          <button
            className="btn-cnf btn-orange w-100 animate-2"
            disabled={select === null}
            // onClick={handleNextClick}
            onClick={handleSignUp}
          >
            {t("Next")}
          </button>
        </div>
        <img
          src={locationIcon2}
          alt=""
          width={176}
          className="d-block"
          style={{
            position: "absolute",
            bottom: "24px",
            right: "0",
            marginRight: "4px",
          }}
        />
      </div>
    </>
  );
}

export default ViaPin;
